import React from "react";

const PaginaArchivos =()=>{
    return (      
        <form action="http://localhost:4000/sismo_sentido/rest/email" 
        enctype="multipart/form-data" method="POST">
        
          <span>Upload Profile Picture:</span>  
          <input type="file" name="archivo" required/> <br/>
          <input type="submit" value="submit"/> 
      </form>
      
    )
}

export default PaginaArchivos;